/** Botão vermelho de encerrar (atendente) ou sair (convidado). Na janela compacta só mostra o ícone. */
import { PhoneOff } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SIZE } from './controlStyles';

/** @param {{ label: string, variant: keyof typeof SIZE, onClick: () => void }} props */
export function EndButton({ label, variant, onClick }) {
    const iconOnly = variant === 'compact';
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={iconOnly ? (label === 'Sair' ? 'Sair da chamada' : 'Encerrar chamada') : undefined}
            title={iconOnly ? label : undefined}
            className={cn(
                'inline-flex items-center justify-center gap-2 rounded-full bg-red-600 text-sm font-medium text-white transition-colors hover:bg-red-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-white',
                SIZE[variant].end,
            )}
        >
            <PhoneOff className={SIZE[variant].icon} aria-hidden="true" />
            {!iconOnly && label}
        </button>
    );
}
